var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeSampleGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5815_19986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 7.53125H1.90625V14.0938C1.90625 14.3424 2.00502 14.5808 2.18084 14.7567C2.35665 14.9325 2.59511 15.0312 2.84375 15.0312H13.1562C13.4049 15.0312 13.6433 14.9325 13.8192 14.7567C13.995 14.5808 14.0938 14.3424 14.0938 14.0938V7.53125Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 4.71875H1.90625C1.65761 4.71875 1.41915 4.81752 1.24334 4.99334C1.06752 5.16915 0.96875 5.40761 0.96875 5.65625V7.0625C0.96875 7.18682 1.01814 7.30605 1.10604 7.39396C1.19395 7.48186 1.31318 7.53125 1.4375 7.53125H14.5625C14.6868 7.53125 14.806 7.48186 14.894 7.39396C14.9819 7.30605 15.0312 7.18682 15.0312 7.0625V5.65625C15.0312 5.40761 14.9325 5.16915 14.7567 4.99334C14.5808 4.81752 14.3424 4.71875 14.0938 4.71875Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53125 4.71875C5.46 4.71875 3.3125 3.04 3.3125 0.96875",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 0.96875C5.38375 0.96875 7.53125 2.6475 7.53125 4.71875",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 4.71875C10.54 4.71875 12.6875 3.04 12.6875 0.96875",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 0.96875C10.6163 0.96875 8.46875 2.6475 8.46875 4.71875",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59375 4.71875H9.40625V15.0312H6.59375V4.71875Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5815_19986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeSampleGift);
export default __webpack_public_path__ + "static/media/free-sample-gift.e9468558853161949ed97727b8888ce8.svg";
export { ForwardRef as ReactComponent };